// src/contexts/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { onAuthStateChanged,  signOut, signInWithPopup,GoogleAuthProvider } from "firebase/auth";
import { auth } from "../firebase";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

export const AuthProvider = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (user) => {
      setCurrentUser(user);
    });
    return unsubscribe;
  }, []);

  const loginWithGoogle = async () => {
    const provider = new GoogleAuthProvider();
    try {
        const result = await signInWithPopup(auth, provider);
        const email = result.user.email;

        // Restrict login to @itstoday.org domain
        if (!email.endsWith("@itstoday.org")) {
            await signOut(auth); // Immediately sign out
            throw new Error("Unauthorized domain. Please use an @itstoday.org email.");
        }

        return result.user;
    } catch (error) {
        console.error("Login failed:", error);
        throw error;
    }
};

  const logout = () => {
    setCurrentUser(null)
    return signOut(auth);
  };

  const value = {
    currentUser,
    loginWithGoogle,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};